module.exports = __webpack_public_path__ + "static/img/video.110b96d1.gif";